import { ContentModal, Header } from './styles';

export function PrivacyPolicy() {
  return (
    <>
      <Header>
        <div className="subHeader">
          <h1>Política de Privacidade</h1>
        </div>
      </Header>
      <ContentModal>
        <h1>1.OBJETIVO</h1>
        <p>
          No <strong>LEGAL HUB</strong>, privacidade e segurança são prioridades e nos comprometemos
          com a transparência no tratamento de seus dados pessoais. Por isto, esta política tem o
          objetivo de estabelecer as diretrizes para a coleta, uso, armazenamento, tratamento e
          proteção dos dados pessoais de usuários e clientes.
        </p>
        <p>
          Assim, ao se cadastrar no sistema <strong>LEGAL HUB</strong>, você entende que coletaremos
          e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas de
          Proteção de Dados (LGPD, Lei Federal 13.709/2018) e demais legislações brasileiras
          aplicáveis.
        </p>
        <h1>2.REFERÊNCIAS</h1>
        <ul>
          <li>Lei 13.709/2018 - Lei Geral de Proteção de Dados.</li>
        </ul>
        <h1>3.DEFINIÇÕES</h1>
        <p>
          <strong>Usuário</strong>: todas as pessoas físicas que se cadastrarem no sistema Legal
          Hub, maiores de 18 (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos
          da vida civil ou os absolutamente ou relativamente incapazes devidamente representados ou
          assistidos.
        </p>
        <p>
          <strong>Dados Pessoais:</strong> significa quaisquer informações fornecidas/cadastradas no{' '}
          <strong>LEGAL HUB</strong>, por qualquer meio, ainda que públicos, que: (I) identifiquem,
          isoladamente ou quando usadas em combinação com outras informações tratadas pelo{' '}
          <strong>LEGAL HUB</strong> identifiquem um indivíduo; ou (II) por meio das quais a
          identificação ou informações de contato de uma pessoa física possam ser derivadas. Os
          Dados Pessoais podem estar em qualquer mídia ou formato, inclusive registros eletrônicos
          ou computadorizados, bem como em arquivos baseados em papel.
        </p>
        <p>
          <strong>Finalidade:</strong> o objetivo é a contratação dos serviços das pessoas
          cadastradas no sistema <strong>LEGAL HUB</strong>.
        </p>
        <p>
          <strong>Necessidade:</strong> justificativa pelo qual é estritamente necessário coletar
          dados pessoais, para atingir a finalidade, evitando-se a coleta excessiva.
        </p>
        <p>
          <strong>Bases legais</strong>: fundamentação legal que torna legítimo o tratamento de
          dados pessoais para uma determinada finalidade prévia por parte do{' '}
          <strong>LEGAL HUB</strong>.
        </p>
        <p>
          <strong>Consentimento:</strong> autorização expressa e inequívoca dada pelo Usuário
          titular do dado pessoal para que o <strong>LEGAL HUB</strong> trate seus dados pessoais
          para uma finalidade previamente descrita, na qual a base legal necessária para o ato
          demande a autorização expressa do titular.
        </p>
        <h1>4.DIRETRIZES GERAIS E ESPECÍFICAS</h1>
        <p>
          Esta política se aplica, em geral, a todos os Usuários e potenciais Usuários dos serviços
          oferecidos pelo <strong>LEGAL HUB</strong> e resume como poderemos coletar, produzir,
          receptar, classificar, utilizar, acessar, reproduzir, transmitir, distribuir, processar,
          arquivar, armazenar, eliminar, avaliar ou controlar a informação, modificar, comunicar,
          transferir, difundir ou extrair os dados coletados, incluindo as informações de
          identificação pessoal, de acordo com as bases legais aplicáveis e todas as leis de
          privacidade e proteção de dados em vigor.
        </p>
        <p>
          Caso o Usuário não se enquadre nas diretrizes acima e/ou não concorde, ainda que em parte,
          com as condições contidos nesta Política de Privacidade, não deverá participar, acessar
          e/ou utilizar os serviços oferecidos pelo <strong>LEGAL HUB</strong>.
        </p>
        <h1>Dos Cookies</h1>
        <p>
          As informações pessoais significam dados relacionados a um indivíduo e que identificam
          esse indivíduo, direta ou indiretamente, como seu nome ou suas informações de contato.
        </p>
        <p>
          Um cookie é um dado que a plataforma solicita ao seu navegador para armazenar no seu
          computador ou dispositivo móvel.
        </p>
        <p>
          A plataforma usa cookies para melhorar o desempenho e aprimorar a sua experiência de
          navegação permitindo que a plataforma guarde as ações do usuário ao longo do tempo.
        </p>
        <p>
          A maioria dos navegadores da Internet aceitam cookies, entretanto, os usuários podem
          configurar seus navegadores para recusar certos tipos de cookies ou cookies específicos.
          Além disso, podem apagar os cookies a qualquer momento.
        </p>
        <h1>4.1.Coleta e Uso de Informações Pessoais</h1>
        <p>
          O <strong>LEGAL HUB</strong> apenas trata Dados Pessoais em situações em que está
          autorizado legalmente ou mediante o expresso e inequívoco consentimento do Usuário.
        </p>
        <p>
          Assim, o Usuário está ciente de que fornece informação de forma consciente e voluntária
          por meio do preenchimento de seus dados no sistema.
        </p>
        <p>
          Conforme descrito na presente Política, o <strong>LEGAL HUB</strong> tem bases legais para
          coletar, produzir, receptar, classificar, utilizar, acessar, reproduzir, transmitir,
          distribuir, processar, arquivar, armazenar, eliminar, avaliar ou controlar a informação,
          modificar, comunicar, transferir, difundir ou extrair dados sobre o Usuário.
        </p>
        <p>
          Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados só serão coletados,
          tratados e armazenados mediante prévio e expresso consentimento, evidenciando o
          compromisso de transparência e boa-fé do <strong>LEGAL HUB</strong>, para com seus
          usuários, seguindo as regulações legislativas pertinentes.
        </p>
        <h1>4.2.Compartilhamento e tratamento de Dados Pessoais</h1>
        <p>
          O <strong>LEGAL HUB</strong> não disponibilizará Dados Pessoais coletados para outras
          finalidades que não sejam para a viabilização da prestação de serviços, nos comprometendo,
          no entanto, a implementar todas as medidas técnicas e organizacionais apropriadas, de
          forma a proteger todos os dados coletados.
        </p>
        <p>
          O <strong>LEGAL HUB</strong> poderá divulgar os Dados Pessoais coletados a terceiros, nas
          seguintes situações e nos limites exigidos e autorizados pela Lei:
        </p>
        <div>
          <ol>
            <li>
              Com os seus clientes e parceiros quando necessário e/ou apropriado à prestação de
              serviços relacionados;
            </li>
            <li>
              Com as empresas e indivíduos contratados para a execução de determinadas atividades e
              serviços em nome do <strong>LEGAL HUB</strong>;
            </li>
            <li>
              III. Com fornecedores e parceiros para consecução dos serviços contratados com o
              <strong> LEGAL HUB</strong> (como tecnologia da informação, contabilidade, entre
              outros);
            </li>
            <li>
              Para propósitos administrativos como: pesquisa, planejamento, desenvolvimento de
              serviços, segurança e gerenciamento de risco.
            </li>
            <li>
              Quando necessário em decorrência de obrigação legal, determinação de autoridade
              competente, ou decisão judicial.
            </li>
          </ol>
        </div>
        <p>
          Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os sujeitos
          mencionados nos itens I a V deverão utilizar os Dados Pessoais partilhados de maneira
          consistente e de acordo com os propósitos para os quais foram coletados (ou com os quais o
          Usuário consentiu previamente) e de acordo com o que foi determinado por esta Política de
          Privacidade.Nas hipóteses de compartilhamento de Dados Pessoais com terceiros, todos os
          sujeitos mencionados nos itens I a V deverão utilizar os Dados Pessoais partilhados de
          maneira consistente e de acordo com os propósitos para os quais foram coletados (ou com os
          quais o Usuário consentiu previamente) e de acordo com o que foi determinado por esta
          Política de Privacidade.
        </p>
        <p>
          Em certas circunstâncias, o <strong>LEGAL HUB</strong> poderá divulgar Dados Pessoais, na
          medida necessária ou apropriada, para órgãos governamentais, consultores e outros
          terceiros com o objetivo de cumprir com a legislação aplicável ou com uma ordem ou
          intimação judicial ou, ainda, se acreditar de boa-fé que tal ação seja necessária para:
        </p>
        <div>
          <ol>
            <li>Cumprir com uma legislação que exija tal divulgação;</li>
            <li>
              Investigar, impedir ou tomar medidas relacionadas a atividades ilegais suspeitas ou
              reais ou para cooperar com órgãos públicos ou para proteger a segurança nacional;
            </li>
            <li>Execução de seus contratos;</li>
            <li>
              Investigar e se defender contra quaisquer reivindicações ou alegações de terceiros;
            </li>
            <li>Proteger a segurança ou a integridade dos serviços;</li>
            <li>
              Exercer ou proteger os direitos, a propriedade e a segurança do
              <strong> LEGAL HUB</strong> e suas empresas coligadas;
            </li>
            <li>
              Proteger os direitos e a segurança pessoal de seus funcionários, usuários ou do
              público;
            </li>
            <li>
              Em caso de venda, compra, fusão, reorganização, liquidação ou dissolução do
              <strong> LEGAL HUB</strong>.
            </li>
          </ol>
        </div>
        <p>
          O <strong>LEGAL HUB</strong> poderá cientificar os respectivos Usuários sobre eventuais
          demandas legais que resultem na divulgação de informações pessoais, nos termos do que foi
          exposto, a menos que tal cientificação seja vedada por lei ou proibida por mandado
          judicial ou, ainda, se a requisição for emergencial.
        </p>
        <h1>4.3.Armazenamento e Segurança dos Dados Pessoais</h1>
        <p>
          Os dados coletados, inclusive os Dados Pessoais, serão utilizados e armazenados durante o
          tempo necessário para que as finalidades elencadas na presente Política de Privacidade
          sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores.
        </p>
        <p>
          De modo geral, seus dados serão mantidos enquanto a relação entre você e o
          <strong> LEGAL HUB</strong> perdurar. Findado o período de armazenamento dos dados
          pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as
          hipóteses legalmente previstas no artigo 16 da Lei Geral de Proteção de Dados - LGPD, a
          saber:
        </p>
        <div>
          <ol>
            <li>Cumprimento de obrigação legal ou regulatória pelo controlador;</li>
            <li>
              Estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados
              pessoais;
            </li>
            <li>
              Transferência a terceiro, desde que respeitados os requisitos de tratamento de dados
              dispostos nesta Lei; ou
            </li>
            <li>
              Uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados
              os dados.
            </li>
          </ol>
        </div>
        <p>
          Isto é, informações pessoais sobre você que sejam imprescindíveis para o cumprimento de
          determinações legais, judiciais e administrativas e/ou para o exercício do direito de
          defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos
          demais dados.
        </p>
        <p>
          O <strong>LEGAL HUB</strong> se compromete a adotar as melhores posturas para evitar
          incidentes de segurança. Contudo, é necessário destacar que nenhuma página virtual é
          inteiramente segura e livre de riscos. É possível que, apesar de todos os nossos
          protocolos de segurança, problemas de culpa exclusivamente de terceiros ocorram, como
          ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do
          próprio usuário.
        </p>
        <p>
          Em caso de incidentes de segurança que possa gerar risco ou dano relevante, nos
          comprometemos a comunicar nossos usuários e a Autoridade Nacional de Proteção de Dados
          sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.
        </p>
        <h1>4.4.Direitos do Usuários</h1>
        <p>
          O <strong>LEGAL HUB</strong> assegura a seus usuários seus direitos de titular previstos
          no artigo 18 da Lei Geral de Proteção de Dados. Dessa forma, você pode, de maneira
          gratuita e a qualquer tempo:
        </p>
        <ol>
          <li>
            <strong>Confirmar a existência de tratamento de dados</strong>, de maneira simplificada
            ou em formato claro e completo.
          </li>
          <li>
            <strong>Corrigir seus dados</strong>, ao solicitar a edição, correção ou atualização
            destes.
          </li>
          <li>
            <strong>Eliminar seus dados</strong> tratados a partir de seu consentimento, exceto nos
            casos previstos em lei.
          </li>
          <li>
            <strong>Informar-se sobre a possibilidade de não fornecer seu consentimento</strong> e
            sobre as consequências da negativa.
          </li>
        </ol>
        <p>
          Para o exercício destes direitos, você deve entrar em contato com o
          <strong> LEGAL HUB</strong>, através dos meios disponíveis nesta Política.
        </p>
        <p>
          Para estas situações e de forma a garantir a sua correta identificação como titular dos
          dados pessoais objeto da solicitação, é possível que solicitemos documentos ou demais
          comprovações que possam garantir sua identidade. Nessa hipótese, você será informado
          previamente.
        </p>
        <h1>4.5.Alterações desta Política de Privacidade</h1>
        <p>
          Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo,
          principalmente em função da adequação a eventuais alterações feitas em nosso sistema ou em
          âmbito legislativo. Recomendamos que você a revise com frequência.
        </p>
        <p>
          Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as
          consente.
        </p>
        <h1>4.6.Responsabilidades e Contato</h1>
        <p>
          Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas
          disposições e zelando por seu cumprimento, assumindo o compromisso de buscar condições
          técnicas e organizativas seguramente aptas a proteger todo o processo de tratamento de
          dados.
        </p>
        <p>
          Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação
          ao tratamento de dados realizado pelo <strong>LEGAL HUB</strong>, comprometemo-nos a
          segui-las.
        </p>
        <p>
          Conforme já mencionado, embora adotemos elevados padrões de segurança a fim de evitar
          incidentes, não há nenhuma página virtual inteiramente livre de riscos. Nesse sentido, não
          nos responsabilizamos por:
        </p>
        <div>
          <ol>
            <li>
              Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos
              usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos
              apenas pela segurança dos processos de tratamento de dados e do cumprimento das
              finalidades descritas no presente instrumento.
              <p>
                Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso
                é do usuário.
              </p>
            </li>
            <li>
              Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta
              culposa ou deliberada do <strong>LEGAL HUB</strong>.
              <p>
                Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano
                relevante aos nossos usuários, comunicaremos aos afetados e a Autoridade Nacional de
                Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias.
              </p>
            </li>
            <li>
              Inveracidade das informações inseridas pelo usuário nos registros necessários e
              quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé, sendo
              estas, de inteira responsabilidade do usuário.
            </li>
          </ol>
        </div>
        <p>
          Caso tenha dúvidas sobre esta Política de Privacidade, sobre os dados pessoais que
          tratamos ou ainda, para o exercício de seus direitos, você pode entrar em contato com a
          nossa equipe, através do e-mail contato.legalhub@legalcontrol.com.br.
        </p>
        <h1>4.7.Foro de Eleição</h1>
        <p>
          Esta política está sujeita à Lei da República Federativa do Brasil e o Foro da Comarca de
          São Paulo é competente para dirimir qualquer controvérsia com relação à mesma.
        </p>
      </ContentModal>
    </>
  );
}
